import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=6d8ba516&scoped=true"
import script from "./certification.vue?vue&type=script&lang=js"
export * from "./certification.vue?vue&type=script&lang=js"
import style0 from "./certification.vue?vue&type=style&index=0&id=6d8ba516&prod&lang=scss"
import style1 from "./certification.vue?vue&type=style&index=1&id=6d8ba516&prod&lang=scss&scoped=true"
import style2 from "./certification.vue?vue&type=style&index=2&id=6d8ba516&prod&lang=css"
import style3 from "./certification.vue?vue&type=style&index=3&id=6d8ba516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ba516",
  null
  
)

export default component.exports